import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { IconEyeOff, IconEyeOn } from 'modules/common/components/Icons';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
// import Logo from 'assets/img/logo-white.png';
import InputMask from 'react-input-mask';
import imagePhone from 'assets/img/img-phone.png';
import APP_VERSION from 'version';
import * as actions from '../actions';
import * as c from '../constants';
import MiniLoader from '../../common/components/MiniLoader';
import CmsContext from '../../../context/CmsContext';
import OtpModal from '../components/OtpModal';

const form = {
  email: '',
  password: '',
  profile_type: 'administrator',
  secret: '',
};

const capitalizeName = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

// const demoData = JSON.parse(localStorage.getItem('demoData'));

function LoginContainer({ isLoading, login, mfaLogin, getLgu, lgu, history }) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const [enable2fa, setEnable2fa] = useState('');
  const [hidden, setHidden] = useState({ hidden: false });
  const [formData, setFormData] = useState(form);
  // const CMS_COLORS = cmsContext.findByType('COLORS');
  const CMS_LOGO = cmsContext.findByType('LOGOS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');
  const cmsLogo =
    _.get(CMS_LOGO, 'CORE_LOGO.cdnUrl') || _.get(CMS_LOGO, 'CORE_LOGO');
  const cmsLogoWhite =
    _.get(CMS_LOGO, 'CORE_LOGO_WHITE.cdnUrl') ||
    _.get(CMS_LOGO, 'CORE_LOGO_WHITE');
  const isIndependentCity = Boolean(
    _.get(lgu, 'municipality.is_independent')
  );

  useEffect(() => {
    getLgu();
  }, []);

  const displayLogoImage = !_.isEmpty(CMS_LOGO) ? (
    <img
      src={!cmsLogoWhite ? cmsLogoWhite : cmsLogo}
      className="front-icon-logo"
      alt="Local Government System"
    />
  ) : (
    <MiniLoader />
  );

  const handleOnChange = (e) => {
    e.preventDefault();
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // const handleOtpChange = (otp) => {
  //   setOtpPayload((prev) => ({
  //     ...prev,
  //     pin: otp,
  //   }));
  // };

  // const handleOtpSubmit = () => {
  //   verifyOtp(otpPayload, (profile) => {
  //     const redirectPage = profile.redirect_page;
  //     setEnable2fa(profile.is_2fa_enabled);
  //     history.push(redirectPage ? _.get(profile, 'redirect_page') : '/');
  //   });
  // };

  const handleLogin = (e) => {
    e.preventDefault();
    login(formData, () => {
      setModal({
        isOpen: true,
        content: <OtpModal />,
        modalSize: 'modal-md',
        hideHeader: true,
      });
    });
  };

  const handleLoginWith2Fa = (e) => {
    e.preventDefault();
    mfaLogin(formData, () => {
      setEnable2fa('');
      history.push('/');
    });
  };

  const handleGoBack = (e) => {
    e.preventDefault();
    setEnable2fa('');
  };

  return (
    <div className="login-page login-core login-background--core">
      <div className="container h-100">
        <div className="row h-100 d-flex align-items-center justify-content-center">
          <div className="col-md-12 mx-auto">
            <div className="login-section">
              <div className="mb-4">
                {displayLogoImage}
              </div>
              <div className="content">
                {enable2fa === '' && (
                  // <div className="login-box">
                  <div className="login-box-smart-city">
                    <div className="d-flex align-items-center mx-auto mb-3">
                      <div className="mr-2">
                        <img
                          src={
                            _.get(CMS_LOGO, 'LOGO.cdnUrl') ||
                            _.get(CMS_LOGO, 'LOGO')
                          }
                          alt=""
                          width={64}
                          height={64}
                        />
                      </div>
                      <div>
                        <h3 className="font-weight-bold mb-0">
                          {capitalizeName(
                            _.get(CMS_VARIABLES, 'ALTERNATE_MUNICIPALITY_NAME')
                              ? _.get(CMS_VARIABLES, 'ALTERNATE_MUNICIPALITY_NAME')
                              : _.get(CMS_VARIABLES, 'MUNICIPALITY_NAME')
                          )}
                        </h3>
                        {!isIndependentCity && (
                          <div className="text-sm">
                            {capitalizeName(
                              _.get(CMS_VARIABLES, 'ALTERNATE_PROVINCE_NAME')
                                ? _.get(CMS_VARIABLES, 'ALTERNATE_PROVINCE_NAME')
                                : _.get(CMS_VARIABLES, 'PROVINCE_NAME')
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="welcome-intro">
                      <h4 className="title-smart-city cms-text-secondary">
                        Login to your account
                      </h4>
                    </div>
                    <form onSubmit={handleLogin} className="login-form">
                      <div className="form-group">
                        <label
                          htmlFor="email"
                          className="form-label-smart-city"
                        >
                          Email Address
                        </label>
                        <input
                          type="email"
                          placeholder="Email Address"
                          onChange={handleOnChange}
                          name="email"
                          value={_.get(formData, 'email') || ''}
                          id="loginUsername"
                          className="form-control form-control-lg"
                          style={{
                            border: '1px solid #D3D3D3',
                            borderRadius: '8px',
                          }} // smart-city
                        />
                      </div>
                      <div className="form-group">
                        <label
                          htmlFor="password"
                          className="form-label-smart-city"
                        >
                          Password
                        </label>
                        <div className="inner-addon right-addon right-addon-button">
                          <input
                            type={hidden ? 'password' : 'text'}
                            placeholder="Password"
                            onChange={handleOnChange}
                            value={_.get(formData, 'password') || ''}
                            name="password"
                            id="loginPassword"
                            className="form-control form-control-lg form-control-icon"
                            style={{
                              border: '1px solid #D3D3D3',
                              borderRadius: '8px',
                            }} // smart-city
                          />
                          <button
                            type="button"
                            tabIndex={-1}
                            className="btn btn-right"
                            onClick={() => setHidden(!hidden)}
                          >
                            {hidden ? <IconEyeOn /> : <IconEyeOff />}
                          </button>
                        </div>
                      </div>
                      {/* <div className="form-helpers action">
                      <Link to="/forgot-password" className="link-action">
                        Forgot Password?
                      </Link>
                    </div> */}
                      <div className="pt-2">
                        <button
                          type="submit"
                          disabled={isLoading}
                          className="btn btn-dark btn-outline-dark btn-block btn-signin"
                          style={{
                            cursor: isLoading ? 'not-allowed' : 'pointer',
                            borderRadius: '8px',
                            fontWeight: 600,
                          }}
                        >
                          {isLoading && (
                            <i className="fas fa-spin fa-spinner" />
                          )}{' '}
                          Login
                        </button>
                      </div>
                    </form>
                    <div className="row">
                      <div className="col-md-12 d-flex justify-content-center mt-3 text-muted">
                        <small>{APP_VERSION}</small>
                      </div>
                    </div>
                  </div>
                )}
                {enable2fa === 1 && (
                  <div className="row card px-5 login-box-smart-city">
                    <div>
                      <div className="d-flex">
                        <button
                          href="/"
                          onClick={handleGoBack}
                          type="button"
                          className="btn btn-link common-back"
                        >
                          <i className="fas fa-chevron-left font-weight-bold" />
                        </button>
                        <div
                          className="text-color text-center pb-5 font-weight-bold"
                          style={{ marginTop: 47 }}
                        >
                          2-Step Verification
                        </div>
                      </div>
                      <div className="text-center mb-3">
                        <img
                          src={imagePhone}
                          alt="Local Government System"
                          style={{ width: 150, height: 150 }}
                        />
                      </div>
                      <div className="history-color col-12">
                        <p className="mb-2">
                          You&apos;ve asked us to require a 6-digit login code
                          when anyone tries to access your account from a new
                          device or browser.
                        </p>
                        <p className="mb-5">
                          Enter a 6-digit code from your code generator or
                          third-party app below.
                        </p>
                      </div>
                      <form onSubmit={handleLoginWith2Fa}>
                        <div className="form-group col-12">
                          <InputMask
                            placeholder="Code"
                            className="form-control"
                            maskChar=" "
                            mask="999999"
                            autoComplete="none"
                            id="secret"
                            name="secret"
                            onChange={handleOnChange}
                            value={_.get(formData, 'secret') || ''}
                          />
                        </div>
                        <div className="col-12 mb-5">
                          <button
                            disabled={isLoading}
                            type="submit"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-block"
                          >
                            SUBMIT
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="ilgu-icon col-12">
            <div className="ilgu-icon-cont">
              <div className="cms-text-primary"> Developed by: </div>
              <div>
                <img
                  // className="ilgu-icon-img"
                  alt=""
                  src={
                    _.get(CMS_LOGO, 'FOOTER_LOGO_CORE.cdnUrl') ||
                    _.get(CMS_LOGO, 'FOOTER_LOGO_CORE')
                  }
                  width={130}
                  height={88}
                />
              </div>
            </div>
          </div>
        </div>

        {/* <div className="fixed-bottom text-right">
          <button
            type="button"
            className="btn btn-link text-dark"
            onClick={handleAddModal}
          >
            +
          </button>
          <button
            type="button"
            className="btn btn-link text-dark"
            onClick={handleEditModal}
          >
            -
          </button>
          <button
            type="button"
            className="btn btn-link text-dark"
            onClick={handleSelectModal}
          >
            /
          </button>
        </div> */}
      </div>
    </div>
  );
}

// LoginContainer.defaulProps = {
//   enableProfile: {},
// }

LoginContainer.propTypes = {
  login: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  mfaLogin: PropTypes.instanceOf(Function).isRequired,
  getLgu: PropTypes.instanceOf(Function).isRequired,
  lgu: PropTypes.instanceOf(Object),
  history: PropTypes.instanceOf(Object).isRequired,
};

LoginContainer.defaultProps = {
  lgu: {},
};

const mapStateToProps = ({ api }) => ({
  isLoading: api.loading.indexOf(c.LOGIN) > -1,
  lgu: _.get(api, `${c.GET_LGU}.item`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LoginContainer);
